<div class="stick-top">
  <mat-toolbar><mat-icon>bookmark</mat-icon> Spec.Probs</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/specProbs/0">
      <mat-icon>add</mat-icon>
      Create a new Spec.Prob
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th>
        <div class="vbox">
          NW.Type
          <micro-net-select [(netId)]="filter.netId" ></micro-net-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          MOC
          <micro-moc-select [netId]="filter.netId" [(mocId)]="filter.mocId" ></micro-moc-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Spec.Prob
          <input [(ngModel)]="filter.value">
        </div>
      </th>
      <th>
        <div class="vbox">
          Prob.Cause
          <input [(ngModel)]="filter.probCause">
        </div>
      </th>
      <th>
        <div class="vbox">
          Rep.Acts
          <input [(ngModel)]="filter.repActs">
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td>{{lookupService.lookup('domain', 'nets', element.netId)}}</td>
      <td>{{lookupService.lookup('domain', 'mocs', element.mocId)}}</td>
      <td><a routerLink="/specProbs/{{element.id}}">{{element.value}}</a></td>
      <td>{{element.probCause}}</td>
      <td>{{element.repActs}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
